import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { AppInsightService } from './app-insight.service';
import { ErrorDiagnosticService } from './error-diagnostic.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {

  constructor
  (
      private appInsightService: AppInsightService,
      private errorDiagnosticService: ErrorDiagnosticService
  ) 
  {
    super();
  }

  handleError(error: Error) {
    if (isDevMode()) {
      console.log(error);
    }
    else {
      this.appInsightService.logException(error, this.errorDiagnosticService.getDetails());
    }
  }
}